import React, { useMemo } from 'react';
import classNames from 'classnames';

import Icon, { COLORS, ICONS } from '../general-components/icon';

interface ButtonCommsProps {
	active: boolean;
	disabled: boolean;
	featureToggleOn: boolean;
	onMouseDown: () => void;
	onMouseLeave: () => void;
	onMouseUp: () => void;
	additionalClasses?: string[];
	customOnMessage?: string;
	customOffMessage?: string;
}

export default function ButtonComms({
	active,
	disabled,
	featureToggleOn,
	onMouseDown,
	onMouseLeave,
	onMouseUp,
	additionalClasses,
	customOnMessage,
	customOffMessage,
}: ButtonCommsProps) {
	const addClasses = useMemo((): string[] => (
		additionalClasses || ['defaults']
	), [additionalClasses]);

	const buttonAvailable = useMemo((): boolean => (
		featureToggleOn && !disabled
	), [disabled, featureToggleOn]);

	return (
		<button
			className={classNames(
				'button-comms',
				'background-lighter',
				'round',
				'text-white',
				'no-select',
				...addClasses,
				{
					...(featureToggleOn && { active }),
					disabled: featureToggleOn ? disabled : true,
				},
			)}
			onMouseDown={buttonAvailable ? onMouseDown : undefined}
			onMouseUp={buttonAvailable ? onMouseUp : undefined}
			onMouseLeave={buttonAvailable ? onMouseLeave : undefined}
			disabled={!buttonAvailable}
			data-testid="button-comms"
		>
			{featureToggleOn ? (
				<>
					<Icon
						className="margin-right-small"
						name={ICONS.HEADPHONES}
						color={COLORS.WHITE}
						size={18}
					/>
					<span className="font-weight-heavy">{customOnMessage ?? 'LIVE'}</span>
				</>
			) : (
				<>
					<Icon
						className="margin-right-small"
						name={ICONS.SOUND}
						color={COLORS.WHITE}
						size={18}
					/>
					<span className="font-size-12">
						{customOffMessage ?? 'COMMS OFF'}
					</span>
				</>
			)}
		</button>
	);
}
